// 引入 ECharts 主模块
let echarts = require("echarts/lib/echarts");

require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/chart/pie");
require("echarts/lib/chart/scatter");
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/legend");
require("echarts/extension/bmap/bmap");
const tdTheme = {
  color: [
    '#818181',
    '#01A63D',
    '#FF8315',
    '#0273FF',
    '#00C0FF'
  ],
  backgroundColor: "rgba(0,0,0,0)",
  textStyle: {},
  title: {
    textStyle: {
      color: "#516b91"
    },
    subtextStyle: {
      color: "#93b7e3"
    }
  },
  grid: {
    // 'left': '5%',
    // 'top': '10%',
    // 'right': '5%'
    // 'bottom': '0'
  },
  bar: {
    itemStyle: {
      normal: {
        barBorderWidth: 0,
        barBorderColor: "#ccc"
      },
      emphasis: {
        barBorderWidth: 0,
        barBorderColor: "#ccc"
      }
    }
  },
  pie: {
    itemStyle: {
      normal: {
        borderWidth: 0,
        borderColor: "#ccc"
      },
      emphasis: {
        borderWidth: 0,
        borderColor: "#ccc"
      }
    }
  },
  scatter: {
    itemStyle: {
      normal: {
        borderWidth: 0,
        borderColor: "#ccc"
      },
      emphasis: {
        borderWidth: 0,
        borderColor: "#ccc"
      }
    }
  },
  boxplot: {
    itemStyle: {
      normal: {
        borderWidth: 0,
        borderColor: "#ccc"
      },
      emphasis: {
        borderWidth: 0,
        borderColor: "#ccc"
      }
    }
  },
  graph: {
    itemStyle: {
      normal: {
        borderWidth: 0,
        borderColor: "#ccc"
      }
    },
    lineStyle: {
      normal: {
        width: 1,
        color: "#aaa"
      }
    },
    symbolSize: "6",
    symbol: "emptyCircle",
    smooth: true,
    color: ["#2d8cf0", "#19be6b", "#f5ae4a", "#9189d5", "#56cae2", "#cbb0e3"],
    label: {
      normal: {
        textStyle: {
          color: "#eee"
        }
      }
    }
  },
  categoryAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#cccccc"
      }
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333"
      }
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: "#888888"
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ["#eeeeee"]
      }
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"]
      }
    },
    nameLocation: "center",
    nameTextStyle: {
      // 'padding': '70',
      color: "#999"
    }
  },
  valueAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#cccccc"
      }
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333"
      }
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: "#888888"
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ["#eeeeee"]
      }
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"]
      }
    },
    nameLocation: "center",
    nameGap: "50",
    nameTextStyle: {
      // 'padding': '20',
      color: "#888888"
    }
  },
  logAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#cccccc"
      }
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333"
      }
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: "#888888"
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ["#eeeeee"]
      }
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"]
      }
    }
  },
  timeAxis: {
    axisLine: {
      show: true,
      lineStyle: {
        color: "#cccccc"
      }
    },
    axisTick: {
      show: false,
      lineStyle: {
        color: "#333"
      }
    },
    axisLabel: {
      show: true,
      textStyle: {
        color: "#888888"
      }
    },
    splitLine: {
      show: true,
      lineStyle: {
        color: ["#eeeeee"]
      }
    },
    splitArea: {
      show: false,
      areaStyle: {
        color: ["rgba(250,250,250,0.05)", "rgba(200,200,200,0.02)"]
      }
    }
  },
  toolbox: {
    show: false
  },
  legend: {
    textStyle: {
      color: "#888888"
    }
    // 'icon': 'line'
    // 'bottom': '5%'
  },
  tooltip: {
    axisPointer: {
      lineStyle: {
        color: "#ccc",
        width: 1
      },
      crossStyle: {
        color: "#ccc",
        width: 1
      }
    }
  },
  timeline: {
    lineStyle: {
      color: "#8fd3e8",
      width: 1
    },
    itemStyle: {
      normal: {
        color: "#8fd3e8",
        borderWidth: 1
      },
      emphasis: {
        color: "#8fd3e8"
      }
    },
    controlStyle: {
      normal: {
        color: "#8fd3e8",
        borderColor: "#8fd3e8",
        borderWidth: 0.5
      },
      emphasis: {
        color: "#8fd3e8",
        borderColor: "#8fd3e8",
        borderWidth: 0.5
      }
    },
    checkpointStyle: {
      color: "#8fd3e8",
      borderColor: "rgba(138,124,168,0.37)"
    },
    label: {
      normal: {
        textStyle: {
          color: "#8fd3e8"
        }
      },
      emphasis: {
        textStyle: {
          color: "#8fd3e8"
        }
      }
    }
  },
  dataZoom: {
    backgroundColor: "rgba(0,0,0,0)",
    dataBackgroundColor: "rgba(255,255,255,0.3)",
    fillerColor: "rgba(167,183,204,0.4)",
    handleColor: "#a7b7cc",
    handleSize: "100%",
    textStyle: {
      color: "#333"
    }
  },
  markPoint: {
    label: {
      normal: {
        textStyle: {
          color: "#888888"
        }
      },
      emphasis: {
        textStyle: {
          color: "#888888"
        }
      }
    }
  }
};

echarts.registerTheme("tdTheme", tdTheme);
export default echarts;